import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
	private storedRoutes = new Map<string, DetachedRouteHandle>();

	shouldDetach(route: ActivatedRouteSnapshot): boolean {
		// Don't detach/cache the dashboard route with the map
		if (this.isDashboardRoute(route)) {
			return false;
		}
		// Allow caching for other routes
		return true;
	}

	store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
		if (route.routeConfig && handle) {
			this.storedRoutes.set(route.routeConfig.path || '', handle);
		}
	}

	shouldAttach(route: ActivatedRouteSnapshot): boolean {
		return !!route.routeConfig && this.storedRoutes.has(route.routeConfig.path || '');
	}

	retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
		return route.routeConfig ? (this.storedRoutes.get(route.routeConfig.path || '') ?? null) : null;
	}

	shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
		// Don't reuse routes for auxiliary outlet 'panel'
		if (future.outlet === 'panel' || curr.outlet === 'panel') {
			return false;
		}

		// Default reuse logic for primary outlet
		return future.routeConfig === curr.routeConfig;
	}

	// Helper to identify the dashboard route
	private isDashboardRoute(route: ActivatedRouteSnapshot): boolean {
		// Adjust this path to match your actual dashboard route
		return (
			route.routeConfig?.path === 'dashboard' || route.routeConfig?.path === '' || route.data['isDashboard'] === true
		);
	}
}
